import React from 'react'

export default function Dertail() {
  return (
    <div>Dertail</div>
  )
}
